import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function MediationPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-handshake-line', title: t('servicePages.mediation.features.f1.title'), desc: t('servicePages.mediation.features.f1.desc') },
    { icon: 'ri-global-line', title: t('servicePages.mediation.features.f2.title'), desc: t('servicePages.mediation.features.f2.desc') },
    { icon: 'ri-team-line', title: t('servicePages.mediation.features.f3.title'), desc: t('servicePages.mediation.features.f3.desc') },
    { icon: 'ri-file-list-3-line', title: t('servicePages.mediation.features.f4.title'), desc: t('servicePages.mediation.features.f4.desc') },
    { icon: 'ri-exchange-line', title: t('servicePages.mediation.features.f5.title'), desc: t('servicePages.mediation.features.f5.desc') },
    { icon: 'ri-shield-star-line', title: t('servicePages.mediation.features.f6.title'), desc: t('servicePages.mediation.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.mediation.details.d1.label'),
      title: t('servicePages.mediation.details.d1.title'),
      body: t('servicePages.mediation.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/facb012225948d4e80ba8fd3837bcb7a.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.mediation.details.d2.label'),
      title: t('servicePages.mediation.details.d2.title'),
      body: t('servicePages.mediation.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=abstract%20global%20business%20network%20map%20with%20glowing%20connection%20nodes%20across%20Europe%2C%20dark%20background%20with%20cyan%20neon%20lines%20linking%20cities%2C%20digital%20trade%20routes%20visualization%2C%20professional%20international%20commerce%20concept%2C%20no%20people%2C%20deep%20navy%20atmosphere&width=800&height=500&seq=mediation-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-links-line"
          label={t('servicePages.mediation.label')}
          title={t('servicePages.mediation.title')}
          subtitle={t('servicePages.mediation.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20elegant%20business%20partnership%20background%20with%20abstract%20glowing%20network%20nodes%20and%20connection%20lines%2C%20deep%20navy%20graphite%20atmosphere%2C%20professional%20mediation%20and%20commerce%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20lighting%2C%20subtle%20neon%20cyan%20accents%2C%20no%20people&width=1920&height=900&seq=mediation-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
